<template>
  <router-link to="/">
    <v-img
      :src="$store.getters.appInfo.logo"
      position="left"
      class="mt-5"
      :max-width="
        isAdmin ? '40px' : $vuetify.breakpoint.mdAndUp ? '70px' : '40px'
      "
      style="image-rendering: optimizeSpeed"
      :title="$t('general.go_to_homepage')"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="primary gray" />
        </v-row>
      </template>
    </v-img>
  </router-link>
</template>

<script>
export default {
  name: "Logo",
  props: {
    isAdmin: Boolean,
  },
};
</script>
